import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Brain, ShieldCheck } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    id: '01',
    title: 'Scan',
    description: 'Point your camera at any ingredient label or upload a photo from your gallery.',
    icon: Camera,
    color: 'bg-blue-100 text-blue-600'
  }, {
    id: '02',
    title: 'Analyze',
    description: 'Our AI instantly identifies and categorizes every ingredient in seconds.',
    icon: Brain,
    color: 'bg-brand-100 text-brand-600'
  }, {
    id: '03',
    title: 'Decide',
    description: 'See which ingredients to avoid and make informed choices for your health.',
    icon: ShieldCheck,
    color: 'bg-accent-100 text-accent-600'
  }];
  return <section id="how-it-works" className="py-20 bg-white relative overflow-hidden" data-id="element-2266" data-mp="14iclp1iq3uyz">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2267" data-mp="19bfeh7fof0e4">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2268" data-mp="2rmpm6j2d95xj">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-2269" data-mp="2mml5arxjq96s">
            How It Works
          </h2>
          <p className="text-lg text-slate-600" data-id="element-2270" data-mp="31bzfu3cuywnr">
            Three simple steps to healthier eating. No complex setup, just point
            and scan.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12" data-id="element-2271" data-mp="3ac5lx4688ucw">
          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="relative group" data-id="element-2272" data-mp="36au6tskzbriy" data-mpi={index}>
              {/* Connector Line (Desktop only) */}
              {index !== steps.length - 1 && <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 border-t-2 border-dashed border-slate-200 -z-10" data-id="element-2273" data-mp="3l1tlm8z00yiw" />}

              <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-2274" data-mp="3tz3vpr02yhm8">
                <div className={`w-16 h-16 rounded-2xl ${step.color} flex items-center justify-center mb-6 mx-auto transform group-hover:scale-110 transition-transform duration-300`} data-id="element-2275" data-mp="7sylx9xfh1cg">
                  <step.icon className="w-8 h-8" data-id="element-2276" data-mp="hi8hizrhd25b" />
                </div>

                <div className="text-center" data-id="element-2277" data-mp="hl4gmrf2dwvc">
                  <span className="inline-block px-3 py-1 rounded-full bg-slate-100 text-slate-500 text-xs font-bold mb-4" data-id="element-2278" data-mp="ljahjit81i8c">
                    STEP {step.id}
                  </span>
                  <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2279" data-mp="vhqa7q7wczjy">
                    {step.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-2280" data-mp="15o1bdz0k8asd">
                    {step.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}